// Форматирование дат, времени и чисел. Время показывается в часовом поясе завода/объекта.

let TZ = "Europe/Moscow";
export function setTimezone(tz: string): void {
  TZ = tz || TZ;
}

const parts = (d: Date, opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat("ru-RU", { timeZone: TZ, ...opts }).format(d);

export function toDate(v: string | Date | null | undefined): Date | null {
  if (!v) return null;
  return v instanceof Date ? v : new Date(v);
}

export function fmtTime(v: string | Date | null | undefined): string {
  const d = toDate(v);
  return d ? parts(d, { hour: "2-digit", minute: "2-digit" }) : "—";
}

export function fmtDate(v: string | Date | null | undefined): string {
  if (!v) return "—";
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-");
    return `${d}.${m}.${y.slice(2)}`;
  }
  const d = toDate(v);
  return d ? parts(d, { day: "2-digit", month: "2-digit", year: "2-digit" }) : "—";
}

export function fmtDay(v: string): string {
  const [y, m, d] = v.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d, 12));
  return new Intl.DateTimeFormat("ru-RU", { weekday: "short", day: "2-digit", month: "2-digit", timeZone: "UTC" }).format(dt);
}

export function fmtDateTime(v: string | Date | null | undefined): string {
  const d = toDate(v);
  return d ? `${parts(d, { day: "2-digit", month: "2-digit" })} ${fmtTime(d)}` : "—";
}

export function fmtNum(v: number | null | undefined, digits = 1): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: digits }).format(v);
}

/** Локальная дата в часовом поясе завода: YYYY-MM-DD. */
export function localISODate(d = new Date()): string {
  const f = new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" });
  return f.format(d);
}

export function addDays(iso: string, n: number): string {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + n, 12));
  return dt.toISOString().slice(0, 10);
}

function tzOffsetMinutes(at: Date): number {
  const p = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(at);
  const get = (t: string) => Number(p.find((x) => x.type === t)?.value);
  const asUTC = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second"));
  return Math.round((asUTC - at.getTime()) / 60000);
}

/** Локальные дата и время завода → ISO в UTC (для API). */
export function zonedISO(date: string, time: string): string {
  const [y, m, d] = date.split("-").map(Number);
  const [hh, mm] = time.split(":").map(Number);
  const guess = Date.UTC(y, m - 1, d, hh, mm);
  const off = tzOffsetMinutes(new Date(guess));
  return new Date(guess - off * 60000).toISOString();
}

/** Минуты от начала локальных суток (для шкалы графика). */
export function minutesOfDay(v: string | Date, dayISO: string): number {
  const d = toDate(v)!;
  const start = new Date(zonedISO(dayISO, "00:00"));
  return (d.getTime() - start.getTime()) / 60000;
}

export function plural(n: number, one: string, few: string, many: string): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b > 1 && b < 5) return few;
  if (b === 1) return one;
  return many;
}

/** Телефон «79161234567» → «+7 916 123-45-67»; остальное — как есть. */
export function fmtPhone(v: string | null | undefined): string {
  if (!v) return "—";
  const d = v.replace(/\D/g, "");
  const n = d.length === 10 ? "7" + d : d.length === 11 && d[0] === "8" ? "7" + d.slice(1) : d;
  if (n.length !== 11 || n[0] !== "7") return v;
  return `+7 ${n.slice(1, 4)} ${n.slice(4, 7)}-${n.slice(7, 9)}-${n.slice(9)}`;
}

/** Номер для ссылки tel: — только цифры с плюсом. */
export function telHref(v: string): string {
  const d = v.replace(/\D/g, "");
  const n = d.length === 10 ? "7" + d : d.length === 11 && d[0] === "8" ? "7" + d.slice(1) : d;
  return "tel:+" + n;
}
